import React from 'react';
import LocalHospitalOutlinedIcon from '@material-ui/icons/LocalHospitalOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';

import { ReactComponent as CalendarIcon } from 'assets/icons/icon-calendar.svg';
import { ReactComponent as SchedulerIcon } from 'assets/icons/icon-scheduler.svg';
import { ReactComponent as ServiceIcon } from 'assets/icons/icon-service.svg';
import { ReactComponent as OrganizationIcon } from 'assets/icons/icon-organization.svg';
import { ReactComponent as AccountManagerIcon } from 'assets/icons/icon-account-manager.svg';
import { ReactComponent as AdminIcon } from 'assets/icons/icon-admin.svg';

export const sideBarLinks = [
  {
    groupTitle: 'Clinics',
    links: [
      {
        label: 'Clinics',
        pathname: '/clinics',
        icon: <LocalHospitalOutlinedIcon />,
      },
    ],
  },
  {
    groupTitle: 'Appointments',
    links: [
      {
        label: 'Calendar',
        pathname: '/calendar',
        icon: <CalendarIcon className="custom-icon" />,
      },
      {
        label: 'Schedulers',
        pathname: '/schedulers',
        icon: <SchedulerIcon className="custom-icon" />,
      },
    ],
  },
  {
    groupTitle: 'Operations',
    links: [
      {
        label: 'Organizations',
        pathname: '/organizations',
        icon: <OrganizationIcon className="custom-icon" />,
      },
      {
        label: 'Services',
        pathname: '/services',
        icon: <ServiceIcon className="custom-icon" />,
      },
      {
        label: 'Bill To',
        pathname: '/bill-to',
        icon: <DescriptionOutlinedIcon />,
      },
    ],
  },
  {
    groupTitle: 'Users',
    links: [
      {
        label: 'Staff',
        pathname: '/staff',
        icon: <PersonOutlineOutlinedIcon />,
      },
      {
        label: 'Account Managers',
        pathname: '/account-managers',
        icon: <AccountManagerIcon className="custom-icon" />,
      },
      {
        label: 'Admins',
        pathname: '/admins',
        icon: <AdminIcon className="custom-icon" />,
      },
    ],
  },
];
